<script lang="ts">
import { computed, defineComponent, inject } from "vue";
import Ueberschrift from "@/components/grid/Ueberschrift.vue";
import Zeile from "@/components/grid/Zeile.vue";
import TitelZelle from "@/components/grid/TitelZelle.vue";
import Zelle from "@/components/grid/Zelle.vue";
import InfoBox from "@/components/grid/InfoBox.vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "VertragsunterlagenDigital",
  components: {
    Ueberschrift,
    Zeile,
    TitelZelle,
    Zelle,
    InfoBox,
    ValidierungsFehler,
  },
  props: {
    fehler: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const piniaStore = useFormStore();
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    const titelText = computed(() => {
      return piniaStore.state.isMakler
        ? "Der Antragssteller möchte seine Vertrags&shy;unterlagen digital erhalten"
        : "Ich möchte meine Vertrags&shy;unterlagen digital erhalten";
    });

    const hinweisText = computed(() => {
      return piniaStore.state.isMakler
        ? "Wenn Ihr Kunde die Vertragsunterlagen künftig ausschließlich digital erhält, spendet die GEV an nachhaltige Projekte. Bitte beachten Sie, dass Ihr Kunde dann künftig die Unterlagen für alle GEV Verträge digital erhalten wird."
        : "Wenn Sie Ihre Vertragsunterlagen künftig ausschließlich digital erhalten, spenden wir an nachhaltige Projekte.";
    });

    return {
      piniaStore,
      wechsleSichtbarkeit,
      titelText,
      hinweisText,
    };
  },
});
</script>

<template>
  <ueberschrift>Vertragsunterlagen digital</ueberschrift>
  <zeile>
    <titel-zelle
      :zeige-info="!piniaStore.state.isMakler"
      info-box-id="infoVertragsunterlagenDigital"
      aria-hidden="true"
    >
      <span v-html="titelText"></span>
    </titel-zelle>
    <zelle class="mkRadio">
      <input
        v-model="piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart"
        type="radio"
        id="standardKommunikationsartEmail"
        name="standardKommunikationsart"
        value="EMAIL"
        required
        aria-required="true"
        aria-label="Ja, ich möchte Vertragsunterlagen digital bekommen"
        tabIndex="0"
        data-cy="standardKommunikationsartEmail"
      />
      <label for="standardKommunikationsartEmail" class="radiolabel">Ja</label>
      <input
        v-model="piniaStore.state.personendaten.versicherungsnehmer.standardKommunikationsart"
        type="radio"
        id="standardKommunikationsartBrief"
        name="standardKommunikationsart"
        value="BRIEF"
        aria-label="Nein, ich möchte Vertragsunterlagen per Postzustellung bekommen"
        data-cy="standardKommunikationsartBrief"
      />
      <label for="standardKommunikationsartBrief" class="radiolabel">Nein</label>
      <validierungs-fehler :fehler-text="fehler.standardKommunikationsart" :reduzierter-abstand="true" />
      <info-box
        id="infoVertragsunterlagenDigital"
        role="tooltip"
        aria-describedby="infoVertragsunterlagenDigital"
        :sichtbarkeit="wechsleSichtbarkeit"
      >
        Bitte beachten Sie, dass Sie künftig für alle Verträge die Unterlagen digital erhalten.
      </info-box>
      <p class="u-copy-s gev19-infotext--grey u-mar-y-0">{{ hinweisText }}</p>
    </zelle>
  </zeile>
</template>
